import { useEffect, useState } from 'react'
import { useEventListener } from 'usehooks-ts'

export type Breakpoint = 'sm' | 'md' | 'lg' | 'xl' | '2xl'
export const BREAKPOINTS: Record<Breakpoint, number> = {
  sm: 640,
  md: 768,
  lg: 1024,
  xl: 1280,
  '2xl': 1536,
}

export function getBreakpoint(width: number): Breakpoint {
  if (width >= BREAKPOINTS['2xl']) return '2xl'
  if (width >= BREAKPOINTS.xl) return 'xl'
  if (width >= BREAKPOINTS.lg) return 'lg'
  if (width >= BREAKPOINTS.md) return 'md'
  return 'sm'
}

export function useBreakpoint() {
  const [breakpoint, setBreakpoint] = useState<Breakpoint>(
    getBreakpoint(typeof window !== 'undefined' ? window.innerWidth : 0)
  )

  useEffect(() => {
    setBreakpoint(getBreakpoint(window.innerWidth))
  }, [])
  useEventListener('resize', () => {
    setBreakpoint(getBreakpoint(window.innerWidth))
  })

  return { breakpoint, breakpointValue: BREAKPOINTS[breakpoint] }
}
